// extracted by mini-css-extract-plugin
export var textarea = "styles-module--textarea--1nBbv";
export var error = "styles-module--error--3MgjS";